// Order of columns is important!
export const NUMERICALSUMMARY_COLUMNS = {
  mean: 'Mean',
  sampleStandardDeviation: 'Standard Deviation',
  count: 'N',
  sum: 'Sum',
  sumOfSquares: 'Sum of Squares',
  standardDeviation: 'Population Standard Deviation',
  min: 'Minimum Value',
  firstQuantile: 'Q1',
  median: 'Median',
  thirdQuantile: 'Q3',
  max: 'Maximum Value'
};


export const CATEGORICAL_SUMMARY_COLUMNS = {
  levels: 'Levels',
  proportions: 'Proportions',
  numberOfObservations: 'Number of Observations',
  totalNumberOfObservations: 'Total Observations'
};
